module.exports = __webpack_public_path__ + "media/images/instagram_48-ff86eb598ca653dbf7f55325f6aadb09.png";